import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import Hotel from "../types/Hotel";

export default function useHotelGet (
    id: string | number,
    options?: CacheQueryOpts
): CacheQueryOutput<Hotel> {
    const endpoint = typeof id === "number" ? `hotels/${id}` : id.substring(1); // Remove leading slash if present
    const client = useAPIClient();
    return useCacheQuery<Hotel>(
        ["hotels", id],
        () => {
            return client.get<any>(endpoint);
        },
        options
    );
}